import { render } from "./MarketingDetails.vue?vue&type=template&id=4f8c0556"
import script from "./MarketingDetails.vue?vue&type=script&lang=js"
export * from "./MarketingDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__